import Childcare from '../components/childcarepage/Childcare';

const ChildcarePage = () => {
    return (
        <>
            <Childcare />
        </>
    );
};

export default ChildcarePage;
